<template>
  <div class="schedules-table mini-schedules-table">
    <DataTable
      name="scheduler"
      :items="filtered"
      :tablehdrs="tableheaders.home.scheduler"
      :itemsperpage="5"
      :paginationOptions="[ 5 ]"
      sortby="scheduling"
      hidefooter
    >
      <template v-slot:default="{ item }">
        <tr
          class="table-row schedules-row mini-schedules-row"
        >
          <td>
            <Customer :value="item.customer" mini hideCpf />
          </td>
          <td class="employees-col">
            <Employees :value="item.employees" mini />
          </td>
          <td>
            {{ item.title }}
          </td>
          <td>
            <p class="mb-0 scheduling-time">
              <v-icon
                small
                color="green"
              >
                mdi-calendar-arrow-left
              </v-icon>
              <span class="ml-1">{{ formatDate(item.start) }}</span>
            </p>
            <p class="mb-0 scheduling-time">
              <v-icon
                small
                color="amber"
              >
                mdi-calendar-arrow-right
              </v-icon>
              <span class="ml-1">{{ formatDate(item.end) }}</span>
            </p>
          </td>
          <td class="status-col">
            <div class="status">
              <v-chip
                dark
                :color="getStatus(item.status).color"
                class="status-chip"
              >
                <v-icon small v-text="getStatus(item.status).icon" class="mr-2" />
                {{ getStatus(item.status).title }}
              </v-chip>
            </div>
          </td>
          <td class="actions-col">
            <Actions :value="item" />
          </td>
        </tr>
      </template>
    </DataTable>
  </div>
</template>

<script>
import DataTable from '@/templates/global/DataTable'
import Customer from '@/components/customers/templates/MiniCard'
import Employees from '@/components/scheduler/launches/templates/Employees'
import Actions from '@/components/scheduler/templates/MenuActions'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import scheduler from '@/components/scheduler/mixins/index'

import moment from 'moment'

export default {
  components: { DataTable, Customer, Employees, Actions },
  mixins: [ appdata, utils, scheduler ],
  props: {
    type: {
      type: Number,
      default: 1
    }
  },
  computed: {
    filtered () {
      let data = (this.get_data.schedules || {}).all || []
      if (this.type === 1) data = data.filter(sch => moment().isSameOrBefore(moment(sch.start)))
      data = data.sort((a, b) => new Date(a.start) - new Date(b.start))
      return data
    }
  }
}
</script>

<style src="@/components/scheduler/styles/list.scss" lang="scss"></style>
<style lang="scss">
.mini-schedules-table {
  #app & {
    .v-data-table-header th {
      padding: 0 7px !important;
    }
    .v-data-table__wrapper {
      border-radius: 7px;
      overflow: hidden;
      .v-data-table-header {
        background: #fcfcfc !important;
      }
    }
  }
}

.schedules-table .mini-schedules-row {
  #app & {
    cursor: pointer;
    background: #fffaf5 !important;
    height: 45px !important;
    td {
      padding: 0 7px !important;
    }
    &:hover {
      filter: brightness(101%) !important;
    }
    .customer-mini-card {
      max-width: 135px !important;
      padding: 5px !important;
    }
    .employees-col {
      max-width: 90px !important;
      position: relative;
      display: inline-block;
      z-index: 1;
    }
    .status-col {
      max-width: 50px;
      .status {
        display: inline-block;
      }
      .status-chip {
        position: relative;
        width: auto;
        max-width: 36px;
        overflow: hidden;
        white-space: nowrap;
        padding: 0 10px !important;
        margin: 0px !important;
        transition: max-width 0.3s ease-in-out;
        &:hover {
          max-width: 100%;
          position: absolute;
          z-index: 999 !important;
          margin-top: -21px !important;
        }
        * {
          pointer-events: none !important;
        }
        .v-icon {
          margin-right: 9px !important;
        }
      }
    }
    .actions-col {
      min-width: 0px !important;
    }
  }
}
</style>
